<template>
    <div class="swap-item-container" :class="{ 'swap-item--invalid': invalid }">
        <img
            @click.stop="closeSwapModal"
            class="close-modal"
            :src="imageUrl('close-modal.png')"
        />
        <div
            class="title replacement"
            v-if="!noProductsFoundMessage"
            :class="{ hasProducts: substituteProducts.length }"
        >
            Swipe to find a replacement Item
        </div>
        <div class="title fade-in" v-else>
            No Substitute Items Found
        </div>
        <transition name="fade">
            <slideshow
                v-if="substituteProducts.length"
                :images="substituteProducts.map((product) => product.product_image_url)"
                :zoomImages="
                    substituteProducts.map((product) => product.product_image_zoom_uri)
                "
                :product="true"
                :classes="{ 'swap-container': true }"
                slideshowHeight="31vh"
            >
            </slideshow>
        </transition>
        <transition name="fade">
            <div v-show="loading" class="loading-overlay">
                <loader></loader>
            </div>
        </transition>
        <div class="product-info" v-if="substituteProducts.length">
            <div class="product-brand" v-if="substituteProduct.product_brand">
                {{ substituteProduct.product_brand }}
            </div>
            <div class="product-title" v-line-clamp="descriptionLineClamp">
                {{ substituteProduct.product_title }}
            </div>
            <div class="product-price">
                {{ substituteProduct.product_price | currency }}
            </div>
        </div>
        <div
            class="buttons-container"
            :class="{ 'with-size-select': showSizeSelect }"
        >
            <div class="select-fix" v-if="showSizeSelect">
                <select
                    @change="setSize"
                    :value="substituteProduct.product_option_value_id_size"
                >
                    <option :value="null">Choose a size</option>
                    <option
                        v-for="size of getSortedSizes"
                        :value="size.product_option_value_id"
                        :key="size.product_option_value_id"
                    >
                        {{ size.product_option_value_title }}
                    </option>
                </select>
            </div>
            <div class="wtw-container small">
                <div
                    @click.stop="swapProduct"
                    class="button pink full-width"
                    :class="{ disabled: !substituteProducts.length || loading }"
                >
                    Swap it!
                </div>
                <div @click.stop="closeSwapModal" class="button outline full-width">
                    Nevermind
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "../common/loader.vue";
import Mixins from "../../mixins/mixins";
import ProductMixins from "../../mixins/product-mixins.js";
import DeactivateScroll from "../../mixins/deactivate-scroll";
import Slideshow from "../common/slideshow.vue";
import $ from "webpack-zepto";

export default {
    data() {
        return {
            substituteProducts: [],
            noProductsFoundMessage: false,
            loading: true,
            index: 0,
            descriptionLineClamp: 2,
            invalid: false,
        };
    },
    components: { Loader, Slideshow },
    props: {
        product: Object,
        showSizes: Boolean,
        swapCb: Function,
    },
    mixins: [Mixins, DeactivateScroll, ProductMixins],
    created() {
        this.$store.commit("menu/hideHeader");
        this.loading = true;

        if (!this.currentOutfit || !this.currentOutfit.isDetailed) {
            const { outfit_id, type } = this.currentOutfit;
            this.$store.dispatch("outfits/fetchOutfit", {
                outfitId: outfit_id,
                outfitType: type,
            }).finally(() => {});
        }

        this.$store
            .dispatch("products/fetchSubstituteProducts", {
                product: this.product,
                size_id: this.showSizes && this.product.product_option_value_id_size,
            })
            .then((response) => {
                if (response.length) {
                    this.noProductsFoundMessage = false;
                    this.substituteProducts = response.map((product) => ({
                        ...product,
                        product_option_value_id_size: null,
                    }));
                } else {
                    this.substituteProducts = [];
                    this.noProductsFoundMessage = true;
                }
                this.loading = false;
                console.log("substitute products:", response);
            })
            .catch((error) => {
                this.loading = false;
                this.noProductsFoundMessage = true;
                console.log(error);
            });

        this.$on("productSwapIndex", (index) => {
            this.index = index;
        });

        this.descriptionLineClamp =
            !this.showSizes || $(window).height() > 764 ? 0 : 2;
    },
    computed: {
        substituteProduct() {
            return (
                (this.substituteProducts && this.substituteProducts[this.index]) || {}
            );
        },
        getSortedSizes() {
            return this.sortSizes(this.getColorSizes(this.substituteProduct)).filter(
                (size) => size.in_stock == 1
            );
        },
        hasSizes() {
            return (
                this.substituteProduct.product_sizes &&
                this.substituteProduct.product_sizes.length > 0
            );
        },
        showSizeSelect() {
            return this.showSizes && this.hasSizes;
        },
        ...mapGetters({
            currentOutfit: "outfits/currentOutfit",
        }),
    },
    beforeDestroy() {
        this.$store.commit("menu/resetHeader");
    },
    methods: {
        closeSwapModal() {
            this.$emit("close");
            this.$parent.$emit("closeSwapModal");
        },
        swapProduct() {
            this.invalid =
                this.showSizes && !this.substituteProduct.product_option_value_id_size;
            if (this.invalid) {
                return;
            }

            this.loading = true;

            const swapPromise =
                typeof this.swapCb === "function"
                    ? this.swapCb(this.substituteProduct)
                    : this.$store.dispatch("outfits/swapProductFromOutfitCurrent", {
                            removeProduct: this.product,
                            swapProduct: this.substituteProduct,
                        });

            return swapPromise
                .then((response) => {
                    this.closeSwapModal();
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },
        setSize(ev) {
            if (ev.target.value) this.invalid = false;
            this.$set(
                this.substituteProduct,
                "product_option_value_id_size",
                ev.target.value
            );
        },
    },
    mounted() {
        setTimeout(() => {
            $(".replacement").addClass("fade-in");
        }, 200);
    },
};
</script>

<style lang="scss" scoped>
.swap-item--invalid {
    .select-fix {
        &::after {
            border-top-color: red;
        }
        select {
            border-color: red;
            color: red;
        }
    }
}
</style>
